import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEventModel} from '../../models/calendar/calendar.model';
import { CalendarEventModalComponent } from 'src/app/shared/modals/calendar-event-modal/calendar-event-modal.component';
import { Subscription } from 'rxjs';
import { AuthMyfileService } from '../auth.myfile.service';


@Injectable({
  providedIn: 'root'
})
export class CalendarModalService {
  
  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal,  private authMyFileService: AuthMyfileService) { }

  openModal(model: CalendarEventModel) {
    var modalRef!: NgbModalRef;

    modalRef = this.modalService.open( CalendarEventModalComponent, { windowClass : "customModalClassUnderName", size: 'lg', centered: false, backdrop: 'static', keyboard: false });

    if(model.createdById && (model.createdById !== this.authMyFileService.currentUserContextValue?.id)){
      modalRef.componentInstance.isOwnerOfEvent = false;
    }else{
      modalRef.componentInstance.isOwnerOfEvent = true;
    }

    modalRef.componentInstance.model = model;

    var sub: Subscription =  modalRef.closed.subscribe(()=>{
      if(modalRef.componentInstance.model){
        this.modelChanged.emit(modalRef.componentInstance.model);
      }
      sub.unsubscribe();
    })
  }

}
